export const RESOURCE_FILES_FETCH_REQUEST = 'RESOURCE_FILES_FETCH_REQUEST';
export const RESOURCE_FILES_FETCH_SUCCESS = 'RESOURCE_FILES_FETCH_SUCCESS';
export const RESOURCE_FILES_FETCH_FAILURE = 'RESOURCE_FILES_FETCH_FAILURE';

export const RESOURCE_FILE_UPLOAD_START = 'RESOURCE_FILE_UPLOAD_START';
export const RESOURCE_FILE_UPLOAD_PROGRESS = 'RESOURCE_FILE_UPLOAD_PROGRESS';
export const RESOURCE_FILE_UPLOAD_SUCCESS = 'RESOURCE_FILE_UPLOAD_SUCCESS';
export const RESOURCE_FILE_UPLOAD_FAILURE = 'RESOURCE_FILE_UPLOAD_FAILURE';
export const RESOURCE_FILE_UPLOADS_CLEAR = 'RESOURCE_FILE_UPLOADS_CLEAR';

export const RESOURCE_FILE_UPDATE_REQUEST = 'RESOURCE_FILE_UPDATE_REQUEST';
export const RESOURCE_FILE_UPDATE_SUCCESS = 'RESOURCE_FILE_UPDATE_SUCCESS';
export const RESOURCE_FILE_UPDATE_FAILURE = 'RESOURCE_FILE_UPDATE_FAILURE';

export const RESOURCE_FILE_DELETE_REQUEST = 'RESOURCE_FILE_DELETE_REQUEST';
export const RESOURCE_FILE_DELETE_SUCCESS = 'RESOURCE_FILE_DELETE_SUCCESS';
export const RESOURCE_FILE_DELETE_FAILURE = 'RESOURCE_FILE_DELETE_FAILURE';
